import { useMatch } from "react-router-dom";
import { getCurrentLanguage, LANGUAGES } from "../../utils/langUtils";
import { UserAnswer, Question } from "./CalculatorContext";
import translation_cs from "./lang/cs.json";
import translation_de from "./lang/de.json";
import translation_en from "./lang/en.json";

export function Language() {
  const match = useMatch("/:lang/*");
  let lang = match && match.params.lang ? match.params.lang : "";

  let translation = translation_cs;

  let language = getCurrentLanguage(lang);
  switch (language) {
    case LANGUAGES.Czech:
      translation = translation_cs;
      break;
    case LANGUAGES.English:
      translation = translation_en;
      break;
    case LANGUAGES.German:
      translation = translation_de;
      break;
  }

  return { translation, language };
}

function getCats(q: Question): string[] {
  const c = q.categories ?? [];
  return Array.isArray(c) ? c : [];
}

export function computeCoverage(questions: Question[], answers: UserAnswer[], translation: any) {
  const totals = new Map<string, number>();
  const covered = new Map<string, number>();
  const cats = new Set<string>();

  const answersMap = new Map<number, string>();
  answers.forEach((answer) => {
    answersMap.set(answer.questionId, answer.answer);
  });

  for (const q of questions) {
    const qCats = getCats(q);
    const w = qCats.length ? 1 / qCats.length : 1;

    qCats.forEach((c) => {
      cats.add(c);
      totals.set(c, (totals.get(c) || 0) + w);

      if (answersMap.get(q.id) === "yes") {
        covered.set(c, (covered.get(c) || 0) + w);
      }
    });
  }

  const labels = Array.from(cats)
    .sort()
    .map((cat) => translation.category[cat] ?? cat);
  const pct = Array.from(cats)
    .sort()
    .map((c) => {
      const t = totals.get(c) || 0;
      const cv = covered.get(c) || 0;
      return t > 0 ? Math.round((100 * cv) / t) : 0;
    });

  return { labels, pct, totals };
}
